import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { FormsLayoutComponent } from '@gwc/forms-layout/forms-layout.component';
import { environment } from '../environments/environment';

const routes: Routes = [

	{
		path: '',
		component: FormsLayoutComponent,
		data: {
			env: environment
		},
		loadChildren: () => import('./pages/casual-hire-form/casual-hire-form.module').then(m => m.CasualHireFormModule)
	}




];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
	preloadingStrategy: PreloadAllModules,
	scrollPositionRestoration: 'enabled',
	initialNavigation: 'enabledBlocking',
	paramsInheritanceStrategy: 'always'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
